import { getLuminance, darken, desaturate } from 'polished';
import cssVars from 'css-vars-ponyfill';
document.addEventListener('DOMContentLoaded', function () {
    const colorJSONEls = document.getElementById('theme-colors');
    if (!colorJSONEls) {
        return;
    }
    const variables = {};
    const { colors } = JSON.parse(colorJSONEls.innerHTML);
    colors.forEach(({ name, value: color }) => {
        // Set the CSS variable itself
        variables[`--${name}-color`] = color;
        // Set hover color of color
        const adjustPercentage = 8;
        let colorResult = darken(adjustPercentage / 100, color);
        colorResult = desaturate(adjustPercentage / 60, colorResult);
        const colorHoverName = `--${name}-color-hover`;
        variables[colorHoverName] = colorResult;
        document.documentElement.style.setProperty(colorHoverName, colorResult);
        // Determine contrast color
        let contrastColor = '#fff';
        if (getLuminance(color) > 0.6) {
            contrastColor = '#111';
        }
        const contrastName = `--${name}-color-contrast`;
        variables[contrastName] = contrastColor;
        document.documentElement.style.setProperty(contrastName, contrastColor);
    });
    // Documentation: https://github.com/jhildenbiddle/css-vars-ponyfill
    cssVars({ exclude: "link[href*='vendor.min.css']", variables });
});
